import React from "react";
import { Link } from "react-router-dom";

/**
 * The standard page header: optional back link, title, subtitle and the
 * page's main buttons on the right. Use it on every HR view page so they all
 * look the same.
 * - back: { to, label } (e.g. { to: "/admin", label: "Administration" })
 * - actions: buttons (right side; wraps under the title on small screens)
 */
const PageHeader = ({ title, subtitle, back, actions, children }) => (
  <div className="d-flex flex-wrap justify-content-between align-items-center gap-2 mb-4">
    <div className="min-w-0">
      {back && (
        <Link
          to={back.to}
          className="text-slate-500 fs-080 text-decoration-none"
        >
          <i className="bi bi-arrow-left"></i> {back.label}
        </Link>
      )}
      <h1 className="fw-bold text-dark m-0 page-title">{title}</h1>
      {subtitle && <p className="text-muted small mb-0">{subtitle}</p>}
      {children}
    </div>
    {actions && <div className="d-flex flex-wrap gap-2">{actions}</div>}
  </div>
);

export default PageHeader;
